import { APP_URL } from "@/config";

export const PLATFORMS = ["TikTok", "Instagram", "YouTube", "X (Twitter)", "Twitch", "Autre"];

export const STATUS_META = {
  todo: { label: "À contacter", c: "text-zinc-300 bg-zinc-800 border-zinc-700" },
  contacted: { label: "Contacté", c: "text-amber-300 bg-amber-500/10 border-amber-500/30" },
  joined: { label: "Inscrit 🎉", c: "text-emerald-300 bg-emerald-500/10 border-emerald-500/30" },
};

export const inviteLink = (code) => `${APP_URL}/onboarding?creator=1&cp=${code}`;

export function buildDM(p, tone) {
  const first = (p.name || p.handle || "").split(" ")[0];
  const link = inviteLink(p.code);
  if (tone === "pro") {
    return `Bonjour ${first || ""},\n\nVotre contenu${p.platform ? ` sur ${p.platform}` : ""} correspond parfaitement à DocLove, l'IA qui décode les conversations amoureuses (red flags, compatibilité, réponses).\n\nNous lançons notre Programme Créateurs : 50% de commission le 1ᵉʳ mois puis 25% récurrents à vie sur chaque abonnement, sans plafond. Votre lien d'affiliation est déjà prêt :\n${link}\n\nSeriez-vous intéressé·e pour en discuter ?`;
  }
  return `Yo ${first || ""} 👋 j'adore ton contenu${p.platform ? ` sur ${p.platform}` : ""} 🔥\n\nOn lance DocLove (l'IA qui analyse les DM/convs, sort les red flags & le style d'attachement, déjà virale sur TikTok 💀). On te propose de rejoindre notre Programme Créateurs : 50% le 1ᵉʳ mois + 25% à vie sur chaque abonné via ton lien. Zéro plafond 💸\n\nTon lien perso est déjà prêt 👉 ${link}\n\nChaud pour en parler ?`;
}
